import {
  Required,
  DataValidator,
  transformKeys,
  IsBoolean,
} from "@/utils/type-vaildator";
import api from "./api";

interface AudioRenameResponse {
  is_duplicate: boolean,
}

class AudioRenameData {
  @Required("isDuplicate cannot be empty")
  @IsBoolean("isDuplicate must be a boolean")
  isDuplicate: boolean;
}

const transformAndValidateData = (
  response: AudioRenameResponse
): AudioRenameData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AudioRenameData);
  } catch (error) {
    console.error("Audio rename data validation failed:", error.message);
    throw error;
  }
};

// 智能体用户音频模板重命名（播客音频）
export const audioRenameTemplate = async ({ id, name, userId }: { id: string, name: string, userId?: string }) => {
  const res = await api.post<AudioRenameResponse>('/audio/rename-template', {
    audio_id: id,
    audio_name: name,
    user_id: userId,
  });
  const data = transformAndValidateData(res.data);  
  return data;
}